exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "textarea{\r\n    font-size:12px;\r\n    font-family:\"Courier New\", Courier, monospace;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/git/flowdesigner/src/app/expression-editor/expression-editor.component.css
// module id = ../../../../../src/app/expression-editor/expression-editor.component.css
// module chunks = 1